/**
 * Guards the "press while already selected" case for `SegmentedControl`.
 * Returns the next value when the selection actually changes, otherwise `null`
 * so the caller can skip the `onChange` notification.
 *
 * Single source of truth shared by `SegmentedControl` and its spec.
 */
export const gateChange = (currentValue: string, nextValue: string): string | null =>
    nextValue === currentValue ? null : nextValue
